import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateTimeInput } from './date-time-input';
import Multiday from './multiday';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";

const DateLabel = () => {
  return (
    <div>
      <span className="capitalize">
        <FormattedMessage id="elements_date_time.date_label.date_time" defaultMessage="Date & Time" />
      </span>
    </div>
  );
};

export class DateTimeMain extends Component {
  constructor (props) {
    super(props);

    this.isValid = this.isValid.bind(this);
    this.getValueFromInput = this.getValueFromInput.bind(this);
    this.scheduleCallback = this.scheduleCallback.bind(this);
    this.getLatestValue = this.getLatestValue.bind(this);
    this.isInputWrappedFunction = this.isInputWrappedFunction.bind(this);
  }

  componentDidMount () {
    this.props.actionFn(this.props.scheduleFromProps);
  }

  getValueFromInput (index, newHash) {
    const { scheduleFromProps } = this.props;
    let newSchedule;
    if (scheduleFromProps.length) {
      newSchedule = scheduleFromProps.map((obj, i) => {
        if (parseInt(index, 10) === i) {
          return newHash;
        }
        return obj;
      });
    }
    newSchedule = newSchedule || [newHash];
    this.props.actionFn(newSchedule);
  }

  scheduleCallback (schedule) {
    this.props.actionFn(schedule);
  }

  isInputWrappedFunction (value) {
    if (_.isFunction(_.get(value, 'getWrappedInstance', ''))) {
      return value.getWrappedInstance();
    }
    if (value && value.refs && value.refs.wrappedInstance) {
      return value.refs.wrappedInstance;
    }
    return value;
  }

  isValid () {
    const { optional } = this.props;
    let noErrors = true;
    // keeping this.refs for backwards compatibility for services still using deprecated string refs
    const componentRefs = _.mapValues(this.refs, (value)=> this.isInputWrappedFunction(value));
    if (!optional) {
      _.forEach(componentRefs, (value) => {
        const isValid = value.isValid();
        if (!isValid) {
          noErrors = false;
        }
      });
    }
    return noErrors;
  }

  getLatestValue () {
    const componentRefs = _.mapValues(this.refs, (value)=> this.isInputWrappedFunction(value));
    return _.map(componentRefs, value => {
      return value.validateDateTime();
    });
  }

  render () {
    const {
      scheduleFromProps,
      multiday,
      preventEditDates,
      isLabel, spaceId,
      calendarPlacement,
      optional,
      noAvailabilityGet,
      excludeBookingIds,
      isBookingForm,
      isHost,
      country,
      useBootstrapGrid = true,
      showDateLabel = true,
      bookingTimes = [],
      afterMidnight = false
    } = this.props;

    const reachedMaxDays = 26 <= scheduleFromProps.length;
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    return (
      <SharedIntlProviderHOC>
        <div className="date-time-container">
          {
            scheduleFromProps.map((dateTimeHash, i) => {
              const uniqueId = `dateTime-${i}`;
              let bookingStart = {};
              let bookingEnd = {};
              if(bookingTimes.length > 0){
                bookingStart = bookingTimes[i]['start'];
                bookingEnd = bookingTimes[i]['end'];
              }
              let label = false;
              if (0 === i && isLabel) {
                label = true;
              }
              return (
                <DateTimeInput
                  key={uniqueId}
                  ref={uniqueId}
                  id={uniqueId}
                  actionFn={this.getValueFromInput}
                  dateLabel={label ? <DateLabel /> : ''}
                  dateTimeHash={dateTimeHash}
                  preventEditDates={preventEditDates}
                  spaceId={spaceId}
                  optional={optional}
                  calendarPlacement={calendarPlacement}
                  noAvailabilityGet={noAvailabilityGet}
                  excludeBookingIds={excludeBookingIds}
                  isBookingForm={isBookingForm}
                  isHost={isHost}
                  country={country}
                  useBootstrapGrid={useBootstrapGrid}
                  showDateLabel={showDateLabel}
                  bookingStart={bookingStart}
                  bookingEnd={bookingEnd}
                  afterMidnight={afterMidnight}
                />
              );
            })
          }
          {
            !optional ? <span className="required">*</span> : null
          }
          {
            multiday ? <Multiday schedule={ scheduleFromProps } scheduleCallback={ this.scheduleCallback } reachedMaxDays={reachedMaxDays}/> : ''
          }

          {
            reachedMaxDays &&
              <div className="col-xs-12 text-xs-left help-block">
                <FormattedMessage
                  id='elements_date_time.date_time_main.contact_peerspace'
                  defaultMessage='Please contact our support team {link} to complete this booking'
                  values={{
                    link: (
                      <a target="_blank" className="underline" href={`https://support.peerspace.com/hc/${zendeskLocale}/requests/new`}>
                        <FormattedMessage
                          id="elements_date_time.date_time_main.here"
                          defaultMessage="here"
                        />
                      </a>
                    )
                  }}
                />
              </div>
          }
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

DateTimeMain.defaultProps = {
  optional: true
};

DateTimeMain.propTypes = {
  scheduleFromProps: PropTypes.array,
  actionFn: PropTypes.func,
  optional: PropTypes.bool,
  multiday: PropTypes.bool,
  preventEditDates: PropTypes.bool,
  isLabel: PropTypes.bool,
  calendarPlacement: PropTypes.string,
  spaceId: PropTypes.string,
  noAvailabilityGet: PropTypes.bool,
  excludeBookingIds: PropTypes.array,
  isBookingForm: PropTypes.bool,
  isHost: PropTypes.bool,
  country: PropTypes.string
};
